import { DateTime } from 'luxon'

export const DateFormatFull = (projectTimeZone = 'Europe/London') => {
  return {
    timeZone: projectTimeZone,
    timeZoneName: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric'
  }
}

export const isoUTCtoIsoWithOffset = (
  value,
  projectTimeZone = 'Europe/London'
) => {
  const dateTime = DateTime.fromISO(value)
  const dateTimeInTZ = dateTime.setZone(projectTimeZone)
  return dateTimeInTZ.toString()
}

export const getBrowserShortDateFormat = () => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
  const locale = new Intl.NumberFormat().resolvedOptions().locale

  const formatter = new Intl.DateTimeFormat(locale, options).formatToParts()

  return formatter
    .map(function (e) {
      switch (e.type) {
        case 'month':
          return 'MM'
        case 'day':
          return 'DD'
        case 'year':
          return 'YYYY'
        default:
          return e.value
      }
    })
    .join('')
}
